export default "__VITE_PUBLIC_ASSET__563efeca__"